import { Route } from 'react-router-dom';
import Layout from '../components/layout';
import TeamList from '../Pages/Team/TeamList';
import ProtectedRoute from '../components/ProtectedRoute';

import NewRole from '../Pages/Team/NewRole';

export const TeamRoutes = ({ menuActive, setMenuActive }) => (
  <>
    <Route path="/team" element={
      <ProtectedRoute>
        <Layout activePage='team' menuActive={menuActive} setMenuActive={setMenuActive}>
          <TeamList />
        </Layout>
      </ProtectedRoute>
    } />
    <Route path="/team/new-role" element={
      <ProtectedRoute>
        <Layout activePage='team' menuActive={menuActive} setMenuActive={setMenuActive}>
          <NewRole />
        </Layout>
      </ProtectedRoute>
    } />
  </>
);